import React from 'react';

export default function Shop(){

    return (
        <div className='container-fluid text-gray'>
            <h1> This is Shop </h1>
        </div>
    )
}  